import React from 'react';

const FilterSelectDropIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.3333 5L7.16667 9.16667L3 5" stroke="#676E7E" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default FilterSelectDropIcon;
